import classes from "./style/PrevArrow.module.css";

function PrevArrow(props) {
  const { className, onClick } = props;
  const style = { left: -15, zIndex: 100 };
  return (
    <div
      className={
        className +
        " rounded bi bi-arrow-left-square-fill " +
        classes["prev-button"]
      }
      style={style}
      onClick={onClick}
    />
  );
}

export { PrevArrow };
